import React from 'react';
import { Box, Typography, Paper, Button, useTheme } from '@mui/material';
import { CreditCard, DollarSign, HelpCircle } from 'lucide-react';

const NoPayoutsPlaceholder = ({ onUpdateBankInfo }) => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        padding: 4,
        textAlign: 'center',
        backgroundColor: theme.palette.background.default,
        border: `1px dashed ${theme.palette.divider}`,
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: `${theme.palette.primary.main}10`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <DollarSign size={36} color={theme.palette.primary.main} />
        </Box>

        <Typography variant="h6" gutterBottom>
          No Payout History Yet
        </Typography>

        <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}>
          You haven't received any payouts yet. Once CircledIn processes your 
          payouts, they'll appear here. Payouts are typically processed after your 
          first billing cycle is complete.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<CreditCard size={18} />}
            onClick={onUpdateBankInfo}
          >
            Update Bank Info
          </Button>
          
          <Button
            variant="text"
            color="primary"
            startIcon={<HelpCircle size={18} />}
            href="https://circledin.zendesk.com/hc/en-us"
            target="_blank"
          >
            Learn About Payouts
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default NoPayoutsPlaceholder;